export const EXTERNAL_MEETING_LINK_ERROR = 'Usa un link de Google Meet, Zoom, Microsoft Teams o Webex.';
export const EXTERNAL_MEETING_LINK_HINT = 'Compatible con Google Meet, Zoom, Microsoft Teams y Webex.';

const ALLOWED_MEETING_DOMAINS = [
    'meet.google.com',
    'zoom.us',
    'zoom.com',
    'teams.microsoft.com',
    'teams.live.com',
    'webex.com',
];

export const normalizeExternalMeetingUrl = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    return /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
};

export const isExternalMeetingUrl = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return true;
    try {
        const url = new URL(normalizeExternalMeetingUrl(raw));
        if (!['http:', 'https:'].includes(url.protocol)) return false;
        const host = url.hostname.toLowerCase();
        return ALLOWED_MEETING_DOMAINS.some(
            (domain) => host === domain || host.endsWith(`.${domain}`),
        );
    } catch {
        return false;
    }
};
